import axios from "axios";
import qs from "qs";

const postAuth = async ({ pageUrl, pageData }) => {
  const data = await axios.post(
    `${process.env.REACT_APP_BACKEND_URL}${pageUrl}`,
    qs.stringify(pageData)
  );
  return data;
};

const signUp = async (pageData) => {
  const data = await axios.post(
    `${process.env.REACT_APP_BACKEND_URL}api/v1/auth/RegisterCustomer.php`,
    qs.stringify(pageData)
  );
  return data;
};

const signIn = async (pageData) => {
  const data = await axios.post(
    `${process.env.REACT_APP_BACKEND_URL}api/v1/auth/LoginCustomer.php`,
    qs.stringify(pageData)
  );
  return data;
};

const signInGuest = async (pageData) => {
  const data = await axios.post(
    `${process.env.REACT_APP_BACKEND_URL}api/v1/auth/LoginGuest.php`,
    qs.stringify(pageData)
  );
  return data;
};

const signInMember = async (pageData) => {
  const data = await axios.post(
    `${process.env.REACT_APP_BACKEND_URL}api/v1/auth/LoginMember.php`,
    qs.stringify(pageData)
  );
  return data;
};

const validateOtp = async (pageData) => {
  const data = await axios.post(
    `${process.env.REACT_APP_BACKEND_URL}api/v1/auth/OtpValidation.php`,
    qs.stringify(pageData)
  );
  return data;
};

const getOtp = async (pageData) => {
  const data = await axios.post(
    `${process.env.REACT_APP_BACKEND_URL}api/v1/auth/GetOtp.php`,
    qs.stringify(pageData)
  );
  return data;
};

const sendOtp = async (pageData) => {
  const data = await axios.post(
    `${process.env.REACT_APP_BACKEND_URL}api/v1/auth/CheckOtp.php`,
    qs.stringify(pageData)
  );
  return data;
};

const pageService = {
  postAuth,
  signIn,
  signInGuest,
  signInMember,
  signUp,
  getOtp,
  sendOtp,
  validateOtp,
};

export default pageService;
